/*******************************************************************************
 * Project：
 * Summary:
 *　　 InpPostalCodeComponent
 * Remarks:
 *     Input postal code common component
 * History：
 *      NghiaTQ            2021/12/27    Create
 ******************************************************************************/
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Utility } from '../../utility/utility';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-inp-postal-code',
  templateUrl: './inp-postal-code.component.html',
  styleUrls: ['./inp-postal-code.component.scss']
})
export class InpPostalCodeComponent implements OnInit, OnChanges {
  @Input() idInp: any;
  @Input() maxLength: any;
  @Input() data: any;
  @Input() valueChange: string;
  @Input() inpClss: string;
  @Input() isDisabled: boolean;
  @Input() item: string;
  @Input() isError = false;
  @Output() outPostal = new EventEmitter();
  @Output() focusInput = new EventEmitter();
  @Output() removeErrorEvent = new EventEmitter();
  sltWithKey: any = [];
  selectedValue: string;
  showDropDown = false;
  lstItem: any[] = [];
  fadeLst = false;
  placementTop = false;
  nextFocus: any;
  count = 0;
  constructor(
    public util: Utility,
    public trans: TranslateService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrBlank(changes) && !this.util.isNullOrBlank(changes.data)) {
      if (!this.util.isNullOrBlank(changes.data.currentValue)) {
        this.lstItem = changes.data.currentValue;
        if (this.lstItem.length === 1) {
          this.selectedValue = this.lstItem[0].Address;
          this.outPostal.emit(this.selectedValue);
        }
      } else {
        this.lstItem = [];
      }
    } else {
      this.lstItem = [];
    }
    if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.isError)) {
      this.isError = changes.isError.currentValue;
    }
  }
  ngOnInit(): void {
    this.lstItem = [];
    this.util.addPerfectScrollBar();
    const a = this.item;
  }
  selected(it: any) {
    const lstfocus = this.lstItem.filter(m => m.active === true || m.focus === true);
    for (const item of lstfocus) {
      item.active = false;
      item.focus = false;
    }
    it.active = true;
    it.focus = true;
    this.selectedValue = it.Address;
    this.outPostal.emit(this.selectedValue);
    this.showDropDown = false;
    this.nextFocus.focus();
    sessionStorage.setItem('isSelectResCode', 'true');
  }
  focus(event, value) {
    if (this.lstItem.length > 1 && this.showDropDown === false) {
      this.togglebutton(null);
      return;
    }
    this.focusInput.emit(value);
    let lstInput;
    let idx = 0;
    const currEle = event.target as HTMLElement;
    if ($('ngb-modal-window').length > 0) {
      lstInput = $('ngb-modal-window input, ngb-modal-window select, ngb-modal-window textarea, ngb-modal-window div[class="textarea-custom"],  ngb-modal-window .tab-button-focus');
    } else {
      lstInput = $('input, select, textarea, div[class="textarea-custom"], .tab-button-focus');
    }
    const lstInputNotDisabled = [];
    lstInput.each((idx, item) => {
      if (item.getAttribute('disabled') === null && item.getAttribute('readonly') === null && !item.classList.contains('inp-filter')) {
        lstInputNotDisabled.push(item);
      }
      if (item.classList.contains('inp-select-focus') && item.getAttribute('disabled') === null) {
        lstInputNotDisabled.push(item);
      }
    });
    if (lstInputNotDisabled.length > 0) {
      const idxOfCurrEle = lstInputNotDisabled.indexOf(currEle);
      // get next element idx
      if (idxOfCurrEle > -1) {
        if (event.shiftKey) {
          idx = idxOfCurrEle === 0 ? lstInputNotDisabled.length - 1 : idxOfCurrEle - 1;
        } else {
          idx = idxOfCurrEle === lstInputNotDisabled.length - 1 ? 0 : idxOfCurrEle + 1;
          this.nextFocus = lstInputNotDisabled[idx];
        }
      } else {
        idx = event.shiftKey ? lstInputNotDisabled.length - 1 : 0;
      }
    }
  }
  outFocus(event: any, pIsSelect: boolean) {
    const el = event.relatedTarget as HTMLElement;
    if (!this.util.isNullOrEmpty(el) && !this.util.isNullOrEmpty(el.classList)){
      if (pIsSelect === true && el.classList.contains('app-postal-code')) {
        return;
      }
    }
    if (this.showDropDown === true) {
      this.showDropDown = false;
    }
  }
  change() {
    if (this.util.isNullOrBlank(this.selectedValue)) {
      const el = document.getElementById(this.idInp);
      if (el && el.textContent) {
        this.selectedValue = el.textContent;
      }
    }
    this.outPostal.emit(this.selectedValue);
  }
  onKeyDownEvent(event: any) {
    this.sltWithKey = [];
    const focusKey = event.key.toUpperCase();
    this.sltWithKey = _.filter(this.lstItem, (it) => {
      return it.Address.startsWith(focusKey);
    });
    if (event.which === 38 || event.which === 40) {
      this.showDropDown = true;
      const index = this.lstItem.findIndex(x => x.focus);
      if (index === -1) {
        this.lstItem[0].focus = true;
      }
      setTimeout(() => {
        $('.drop-show.active button.focus').focus();
      }, 200);
    }
    if (this.showDropDown) {
      this.setPos();
      setTimeout(() => {
        this.util.addPerfectScrollBar();
      });
    }
    if (!this.util.isNullOrEmpty(this.selectedValue)) {
      this.removeErrorEvent.emit();
    }
  }
  onActionEvent(event: any, it: any) {
    if (event.which === 38 || event.which === 40) {
      const index = this.lstItem.findIndex(x => x.focus);
      if (index !== -1) {
        const max = this.lstItem.length - 1;
        this.lstItem[index].focus = false;
        if (event.which === 38) {
          if (index === 0) {
            this.lstItem[max].focus = true;
          } else {
            this.lstItem[index - 1].focus = true;
          }
        }
        if (event.which === 40) {
          if (index === max) {
            this.lstItem[0].focus = true;
          } else {
            this.lstItem[index + 1].focus = true;
          }
        }
      }
      setTimeout(() => {
        $('.drop-show.active button.focus').focus();
      }, 200);
    }
    if (event.which === 9 || event.which === 13) {
      const item = this.lstItem.find(x => x.focus);
      if (item) {
        this.selected(item);
      }
    }
  }
  togglebutton(event: any) {
    this.showDropDown = true;
    this.util.addPerfectScrollBar();
    this.setPos();
  }
  setPos() {
    setTimeout(() => {
      const rowT = $('.multi-select.active').position()?.top;
      const rowH = $('.multi-select.active').height();
      const lstH = $('.drop-show.active').height();
      const tbH = $('.table-common').height();
      if ((rowT + rowH + lstH) > tbH) {
        this.placementTop = true;
      } else {
        this.placementTop = false;
      }
      setTimeout(() => {
        this.fadeLst = true;
      }, 100);
    }, 150);
  }
}
